const carouselItems = [
  {
    tag: '热门追踪',
    title: '某顶流艺人税务风波全解析：从举报到通报的时间线梳理',
    desc: '事件始于匿名举报，历经多部门联合调查，最终通报确认涉及偷逃税款及附加罚款。本文完整梳理从发酵到定性的全过程。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20editorial%20concept%20of%20financial%20documents%20and%20legal%20papers%20scattered%20on%20dark%20surface%2C%20dramatic%20lighting%20from%20side%2C%20warm%20amber%20and%20deep%20crimson%20tones%2C%20investigation%20theme%2C%20cinematic%20mood%2C%20professional%20aesthetic&width=800&height=500&seq=carousel-01-heiliao&orientation=landscape',
    stat: '阅读 128K',
    date: '2026.07.28',
  },
  {
    tag: '深度解读',
    title: '直播带货翻车事件大盘点：2026上半年行业诚信危机回顾',
    desc: '从虚假宣传到产品质量问题，多起头部主播翻车事件引发行业震动。本文盘点上半年最具代表性的案例及其行业影响。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20live%20streaming%20studio%20setup%20with%20products%20on%20display%2C%20dramatic%20contrast%20lighting%2C%20warm%20and%20dark%20atmosphere%2C%20ecommerce%20theme%2C%20editorial%20photography%20style%2C%20mysterious%20vibe&width=800&height=500&seq=carousel-02-heiliao&orientation=landscape',
    stat: '阅读 96K',
    date: '2026.07.25',
  },
  {
    tag: '事件复盘',
    title: '某知名企业数据泄露事件深度剖析：用户信息安全警钟再响',
    desc: '数千万用户数据遭泄露，涉及姓名、手机号、地址等敏感信息。事件暴露了企业在数据安全管理上的重大漏洞。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20digital%20security%20breach%20concept%2C%20dark%20server%20room%20with%20red%20warning%20lights%2C%20data%20flow%20visualization%2C%20cybersecurity%20theme%2C%20dramatic%20atmosphere%2C%20warm%20dark%20tones%20with%20crimson%20accents&width=800&height=500&seq=carousel-03-heiliao&orientation=landscape',
    stat: '阅读 87K',
    date: '2026.07.22',
  },
  {
    tag: '行业揭秘',
    title: '娱乐圈选秀黑幕大起底：从票数造假到合约陷阱的完整产业链',
    desc: '多档选秀节目被曝存在系统性造假行为，涉及票数操控、合约欺诈、选手压榨等问题，揭开选秀产业链的阴暗面。',
    image: 'https://readdy.ai/api/search-image?query=Theater%20stage%20with%20dramatic%20spotlight%20and%20long%20shadows%2C%20dark%20backstage%20atmosphere%2C%20entertainment%20industry%20theme%2C%20mysterious%20and%20cinematic%20lighting%2C%20warm%20amber%20spot%20on%20empty%20stage&width=800&height=500&seq=carousel-04-heiliao&orientation=landscape',
    stat: '阅读 112K',
    date: '2026.07.20',
  },
  {
    tag: '社会热点',
    title: '食品安全黑榜再更新：知名餐饮品牌后厨卫生乱象调查',
    desc: '暗访调查揭露多家连锁餐饮品牌后厨存在严重卫生问题，食材过期、操作不规范等现象触目惊心，引发社会广泛关注。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20restaurant%20kitchen%20scene%20with%20dramatic%20contrast%2C%20stainless%20steel%20surfaces%20in%20dark%20shadow%2C%20food%20safety%20inspection%20theme%2C%20warm%20and%20cold%20lighting%20mix%2C%20cinematic%20documentary%20style&width=800&height=500&seq=carousel-05-heiliao&orientation=landscape',
    stat: '阅读 143K',
    date: '2026.07.18',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            焦点专题
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            精选本周最受关注的黑料事件深度解读专题，了解事件全貌
          </p>
        </div>

        <div className="flex flex-nowrap gap-5 overflow-x-auto pb-4 scrollbar-hide">
          {carouselItems.map((item, idx) => (
            <article
              key={idx}
              className="flex-shrink-0 w-[340px] md:w-[400px] group cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-xl bg-background-100 border border-background-200/60 transition-all duration-300 hover:border-primary-200">
                <div className="relative h-[220px] overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                  <div className="absolute top-3 left-3">
                    <span className="px-3 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-3 text-xs text-foreground-500 mb-3">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {item.stat}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-calendar-line"></i>
                      {item.date}
                    </span>
                  </div>
                  <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                    {item.desc}
                  </p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}